import { StandardDivProps } from '@sprinx/react-mui-components';
import { FavoriteBorder, Favorite } from '@material-ui/icons';
import { IconButton, createStyles, makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import { useRecoilValue } from 'recoil';
import { useToggleIsFavorite, isFavoriteProductSelector } from '../../../api/products/favoriteProducts';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export type ProductDetailFavoriteToggleClassKey = 'root' | 'isFavorite';

export interface ProductDetailFavoriteToggleProps extends StandardDivProps<ProductDetailFavoriteToggleClassKey> {
  productId: string;
}

const themeSettings = { name: 'ProductDetailFavoriteToggle' };
const useStyles = makeStyles(
  () =>
    createStyles<ProductDetailFavoriteToggleClassKey, {}>({
      root: {
        // color: 'red',
        opacity: 0,
      },
      isFavorite: {
        opacity: 1,
        color: 'red',
      },
    }),
  themeSettings,
);

const ProductDetailFavoriteToggle: React.FC<ProductDetailFavoriteToggleProps> = ({
  className,
  classes: pClasses,
  productId,
}) => {
  const classes = useStyles({ classes: pClasses });
  const toggleIsFavorite = useToggleIsFavorite();
  const t = useTranslateWithFallback();
  const isFavorite = useRecoilValue(isFavoriteProductSelector(productId));
  const onToggle = () => toggleIsFavorite(productId);

  return (
    <Tooltip title={isFavorite ? t('app/removeFromFavorites') : t('app/addToFavorites')}>
      <IconButton className={clsx(classes.root, isFavorite && classes.isFavorite, className)} onClick={onToggle}>
        {isFavorite ? <Favorite /> : <FavoriteBorder />}
      </IconButton>
    </Tooltip>
  );
};

export default ProductDetailFavoriteToggle;
